import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Custom Portraits</p>
        <h1>Transform Your Memories into Art</h1>
        <p className="lede">
          Discover the beauty of custom portrait artwork designed specifically for you and your family. 
          Our talented artists capture your unique essence, creating timeless pieces that you'll cherish forever.
        </p>
        <div className="cta-row">
          <a href="/gallery" target="_self">
            Explore Our Gallery
          </a>
          <a href="/order" target="_self" className="secondary">
            Start Your Custom Portrait
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Personalized Artwork</h2>
          <p>
            Each portrait is crafted with care, reflecting your personality and style. Choose from a variety of mediums and sizes to suit your taste.
          </p>
        </article>
        <article>
          <h2>Perfect for Any Occasion</h2>
          <p>
            Whether it's a family gathering, a special celebration, or a gift for a loved one, our portraits make every moment memorable.
          </p>
        </article>
        <article>
          <h2>Easy Ordering Process</h2>
          <p>
            Simply upload your favorite photos, select your preferences, and let our artists do the rest. Your custom portrait will be delivered right to your door.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;